<template>
    <el-card class="box-card-b">
        <el-container>
            <el-header height='38'>
                <div style="display: inline-block; float: left; margin-left: -8px;">
                    <el-input prefix-icon="Search" v-model="tableHead[0].filterInformation"
                        :placeholder="'搜索'+tableHead[0].label" clearable size="small"
                        :autofocus="tableSelect == tableHead[0].property" @change="speechPr()">
                        <template #append>
                            <el-button type="primary" @click="speechPr()" size="small">搜索</el-button>
                        </template>
                    </el-input>
                </div>
                <div style="display: inline-block; float: right; margin-right: -8px;">
                    <el-button size="small" type="primary" @click="clearFilter()">清除筛选
                    </el-button>
                    <el-button size="small" type="primary" @click="handleExport()">导出表
                    </el-button>
                </div>
            </el-header>
            <el-main>
                <el-table :data="fileList" stripe max-height="795" :height="innerHeight - 175" size="small"
                    v-loading="loading">
                    <el-table-column v-for="(item, index) in tableHead" :key="index">
                        <el-table-column :property='item.property' v-if="item.type === 'input'">
                            <template #header>
                                <el-popover :visible="tableSelect == item.property" placement="top-start" title="查询"
                                    :width="240">
                                    <template #reference>
                                        <div @click="tableSelect = item.property">
                                            {{item.label}}
                                            <el-button icon="Filter" size="small" text
                                                :type="item.filterInformation?'primary':'info'" />
                                        </div>
                                    </template>
                                    <template #default>
                                        <el-input v-model="item.filterInformation" :placeholder="'搜索'+item.label"
                                            clearable size="small" :autofocus="tableSelect == item.property">
                                        </el-input>
                                        <div style="text-align: right; margin: 0; padding-top: 4px;">
                                            <el-button size="small" text @click="tableSelect = null">取消</el-button>
                                            <el-button size="small" type="primary" @click="speechPr()">
                                                确认
                                            </el-button>
                                        </div>
                                    </template>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column :property='item.property' v-else-if="item.type === 'number'">
                            <template #header>
                                <el-popover :visible="tableSelect == item.property" placement="top-start" title="查询"
                                    :width="240">
                                    <template #reference>
                                        <div @click="tableSelect = item.property">{{item.label}}
                                            <el-button icon="Filter" size="small" text
                                                :type="item.filterInformation?'primary':'info'" />
                                        </div>
                                    </template>
                                    <template #default>
                                        <el-input v-model="item.filterInformation" placeholder="输入整数或小数" clearable
                                            size="small" :autofocus="tableSelect == item.property">
                                            <template #prepend>
                                                <el-select v-model="item.filterMethod" placeholder="等于" size="small"
                                                    style="width: 60px">
                                                    <el-option label="等于" value="等于" />
                                                    <el-option label="大于" value="大于" />
                                                    <el-option label="大等" value="大等" />
                                                    <el-option label="小于" value="小于" />
                                                    <el-option label="小等" value="小等" />
                                                    <el-option label="不等" value="不等" />
                                                    <el-option label="之间" value="之间" />
                                                </el-select>
                                            </template>
                                        </el-input>
                                        <div style="text-align: right; margin: 0; padding-top: 4px;">
                                            <el-button size="small" text @click="tableSelect = null">取消</el-button>
                                            <el-button size="small" type="primary" @click="speechPr()">
                                                确认
                                            </el-button>
                                        </div>
                                    </template>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column :property='item.property' v-else-if="item.type === 'select'">
                            <template #header>
                                <el-popover :visible="tableSelect == item.property" placement="top-start" title="查询"
                                    :width="240">
                                    <template #reference>
                                        <div @click="tableSelect = item.property">
                                            {{item.label}}
                                            <el-button icon="Filter" size="small" text
                                                :type="(Array.isArray(item.filterInformation) && item.filterInformation.length > 0) ?'primary':'info'" />
                                        </div>
                                    </template>
                                    <template #default>
                                        <el-select v-model="item.filterInformation" multiple style="width: 220px"
                                            filterable allow-create size="small" collapse-tags>
                                            <template #header>
                                                <el-button text type="info" @click="handleCheckFn(index,'all')"
                                                    size="small">全选</el-button>
                                                <el-button text type="info" @click="handleCheckFn(index,'reverse')"
                                                    size="small">反选</el-button>
                                            </template>
                                            <el-option v-for="i in item.options" :key="i" :label="i" :value="i" />
                                        </el-select>
                                        <div style="text-align: right; margin: 0; padding-top: 4px;">
                                            <el-button size="small" text @click="tableSelect = null">取消</el-button>
                                            <el-button size="small" type="primary" @click="speechPr()">
                                                确认
                                            </el-button>
                                        </div>
                                    </template>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column v-else :label="item.label" :property="item.property"></el-table-column>
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer height='38'>
                <el-pagination v-model:current-page="lookup.currentPage" background :page-size="20" hide-on-single-page
                    layout="prev, pager, next" :total="total" @size-change="speechPr" @current-change="speechPr"
                    size="small" />
            </el-footer>
        </el-container>
    </el-card>
</template>

<script>
    import jsonToExcel from '@/utils/jsonToExcel';
    import axios from "@/utils/request";
    // 订单助手页面
    import {
        mapState
    } from 'vuex'
    export default {
        name: 'NotesAssistant',
        computed: {
            // Vue计算属性
            ...mapState(['innerHeight', 'screenWidth']),
        },
        created() {
            //获取侧边列表
            this.loading = true
            axios({
                method: "post",
                url: 'getdataother',
                data: {
                    tabname: '订单助手',
                    currentPage: 1,
                    head: true,
                    where: [],
                    search: {},
                },
            }).then(res => {
                this.loading = false
                this.fileList = res.data
                this.lookup.currentPage = res.current_page
                this.total = res.total
                this.tableHead = res.tableHead
            })
        },
        data() {
            return {
                loading: false,
                fileList: [],
                tableSelect: null,
                tableHead: [{
                    label: '商品名称',
                    property: 'combined_name',
                    type: 'input',
                    filterMethod: '等于',
                    filterInformation: null,
                    export: true
                }],
                lookup: {
                    tabname: '订单助手',
                    search: {},
                    export: false,
                    currentPage: 1,
                    head: false,
                    where: [],
                },
                total: 0,
            }
        },
        methods: {
            async speechPr(currentPages) {
                this.loading = true
                this.tableSelect = null
                this.lookup.where = [];
                this.lookup.export = false;
                this.lookup.head = false;
                this.lookup.currentPage = currentPages ? currentPages : 1
                await this.tableHead.forEach((items) => {
                    if (items.filterInformation) {
                        this.lookup.where.push(items)
                    }
                })
                axios({
                    method: "post",
                    url: 'getdataother',
                    data: this.lookup,
                }).then(res => {
                    this.loading = false
                    this.fileList = res.data
                    this.lookup.currentPage = res.current_page
                    this.total = res.total
                })
            },
            handleExport() {
                this.lookup.export = true;
                this.lookup.head = true;
                axios({
                    method: "post",
                    url: 'getdataother',
                    data: this.lookup,
                }).then(res => {
                    jsonToExcel(res.data, res.tableHead, '产品定价表')

                })
            },
            async clearFilter() {
                this.tableHead = await this.tableHead.map(obj => {
                    obj.filterInformation = null;
                    return obj;
                });
                this.speechPr()
            },
            handleCheckFn(index, fn) {
                if (fn == 'all') {
                    this.tableHead[index].filterInformation = this.tableHead[index].options
                } else {
                    const arr1 = this.tableHead[index].filterInformation;
                    const array2 = this.tableHead[index].options;
                    this.tableHead[index].filterInformation = array2.filter(item => !arr1.includes(item));
                }
            }
        }
    }
</script>

<style scoped>
    .el-row {
        margin-bottom: 5px;
    }

    .my-autocomplete li {
        line-height: normal;
        padding: 7px;
    }

    .my-autocomplete li .name {
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .my-autocomplete li .addr {
        font-size: 12px;
        color: #b4b4b4;
    }

    .my-autocomplete li .highlighted .addr {
        color: #ddd;
    }

    .my-header {
        margin-top: 5px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .affix-container {}

    .infinite-list {
        padding: 0;
        margin: 0;
        list-style: none;
    }

    .infinite-list .infinite-list-item {
        margin-bottom: 8px;
        margin-top: 8px;
        /* margin: 0px; */
    }
</style>